import CheckoutPreview from 'docs/images/integration-builder/checkout-ib.png';

export const PRICE = {
  active: true,
  billing_scheme: 'per_unit',
  created: Date.now(),
  currency: 'usd',
  id: '{{PRICE_ID}}',
  livemode: false,
  lookup_key: null,
  metadata: {},
  nickname: null,
  object: 'price',
  product: {
    active: true,
    attributes: [],
    created: Date.now(),
    description: 'The cover of Stubborn Attachments',
    id: '{{PRODUCT_ID}}',
    images: [CheckoutPreview],
    livemode: false,
    metadata: {},
    name: 'Stubborn Attachments',
    object: 'product',
    package_dimensions: null,
    shippable: null,
    statement_descriptor: null,
    type: 'service',
    unit_label: null,
    updated: 1626804714,
    url: null,
  },
  recurring: null,
  tiers_mode: null,
  transform_quantity: null,
  type: 'one_time',
  unit_amount: 2000,
  unit_amount_decimal: '2000',
  formattedActivePriceAmount: '$20.00',
};

export const BILLING_PRICE = {
  active: true,
  billing_scheme: 'per_unit',
  created: Date.now(),
  currency: 'usd',
  id: '{{PRICE_ID}}',
  livemode: false,
  lookup_key: null,
  metadata: {},
  nickname: null,
  object: 'price',
  product: {
    active: true,
    attributes: [],
    created: Date.now(),
    description: 'Starter plan',
    id: '{{PRODUCT_ID}}',
    images: [CheckoutPreview],
    livemode: false,
    metadata: {},
    name: 'Starter plan',
    object: 'product',
    package_dimensions: null,
    shippable: null,
    statement_descriptor: null,
    type: 'service',
    unit_label: null,
    updated: 1626804714,
    url: null,
  },
  recurring: {
    aggregate_usage: null,
    interval: 'month',
    interval_count: 1,
    usage_type: 'licensed',
  },
  tiers_mode: null,
  transform_quantity: null,
  type: 'recurring',
  unit_amount: 2000,
  unit_amount_decimal: '2000',
  formattedActivePriceAmount: '$20.00 / month',
};
